import { combineEpics } from 'redux-observable';
import {
  deviceCheckoutEpics,
  employeeEpic,
  resourcesEpic,
  selfserviceEpic,
  userEpic,
} from '../../selfservice/epics/index.js';
import type { ActionTypes } from '../../selfservice/actions/index.js';
import type { EpicDependencies } from '../../selfservice/epics/epicUtils.js';
import type { Epic } from 'redux-observable';

export const siteEpic: Epic<ActionTypes, ActionTypes, object, EpicDependencies> = combineEpics(
  selfserviceEpic,
  employeeEpic,
  deviceCheckoutEpics,
  userEpic,
  resourcesEpic
);
